<template>
  <div v-if="attachment" class="document" @click="$emit('document-selected', document)">
    <div class="document__attachment">
      <span
        :class="`${documentStatusClass(document.translatedStatus)}`"
        class="label label--document-status"
      >
        {{ document.translatedStatus || 'Pendente' }}
      </span>
      <img :src="attachment.previewUrl" class="document__img">
      <div v-if="canUploadOrDestroy" class="document__edit-document">
        Clique na imagem para alterá-la
      </div>
      <div class="document__name">
        {{ `${document.translatedKind} - ${translatedOwner}` }}
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import 'assets/stylesheets/utils/_spacing.sass';
  @import 'assets/stylesheets/utils/_colors.sass';
  @import 'assets/stylesheets/bootstrap_variables.scss';

  .document {
    display: flex;
  }

  .document__attachment {
    background-color: rgba($black, 0.75);
    margin: 0 $space-m $space-m $space-m;
    overflow: hidden;
    position: relative;
    width: 200px;
  }

  .document__attachment::after {
    content: '';
    display: block;
    padding-top: 100%;
  }

  .document__img {
    cursor: pointer;
    width: 100%;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate( -50%, -50%);
  }

  .document__edit-document {
    background-color: rgba($black, 0.75);
    color: $white;
    font-weight: bold;
    padding: $space-st $space-xs $space-xs $space-xs;
    position: absolute;
    text-align: center;
    top: 0;
    width: 100%;
  }

  .document__name {
    background-color: rgba($black, 0.75);
    bottom: 0;
    color: $white;
    font-weight: bold;
    padding: $space-xs;
    position: absolute;
    text-align: center;
    width: 100%;
    z-index: 1;
  }

  .label--document-status {
    color: $white;
    position: absolute;
    z-index: 1;
  }

  @media screen and (max-width: $screen-xs-max) {
    .document, .document__attachment {
      width: 100%;
    }
  }
</style>
<script>
import statusLabelClass from 'utils/statusLabelClass';

export default {
  props: {
    owner: {
      type: String,
      required: true,
    },
    canUploadOrDestroyDocument: {
      type: Boolean,
      default: false,
    },
    translatedOwner: {
      type: String,
      required: true,
    },
    document: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultImage: 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=',
    };
  },
  computed: {
    canUploadOrDestroy() {
      return this.document.status !== 'approved' && this.canUploadOrDestroyDocument;
    },
    attachment() {
      return (
        this.document.attachments
          ? this.document.attachments[0]
          : { previewUrl: this.defaultImage }
      );
    },
  },
  methods: {
    documentStatusClass(status) {
      return statusLabelClass(status);
    },
  },
};
</script>
